import React, { useState } from 'react';
import './OrderTabs.css';
import { useParams } from 'react-router-dom';
import Overview from './Overview';
import TaskList from './TaskList';
import Documents from './Documents';
import Gantt from './Gantt';
import History from './History';
import SalesTaskList from './SalesTaskList';
import DesignPhaseTaskList from './DesignPhaseTaskList';
import DesignTaskList from './DesignTaskList';

export default function OrderTabs() {

    const { projectId } = useParams(); // Extract projectId from the URL
    console.log("Texting", projectId);
  const [activeTab, setActiveTab] = useState('Overview');

  const tabs = ['Overview', 'Tasks', 'Documents', 'History'];

  return (
    <div>
    <div className="order-tabs">
      {tabs.map(tab => (
        <button
          key={tab}
          className={`tab ${activeTab === tab ? 'active' : ''}`}
          onClick={() => setActiveTab(tab)}
        >
          {tab}
        </button>
      ))}
    </div>
    <div className="tab-content">
        {activeTab === 'Overview' && <Overview projectId={projectId} />}
        {/* {activeTab === 'Tasks' && <TaskList />} */}
        {activeTab === 'Tasks' && <SalesTaskList />}
        {/* {activeTab === 'Tasks' && <DesignPhaseTaskList />} */}
        {/* {activeTab === 'Tasks' && <DesignTaskList />} */}
        {activeTab === 'Documents' && <Documents />}
        {activeTab === 'History' && <History />}
        {/* {activeTab === 'Gantt' && <Gantt />} */}
      </div>
    </div>
  );
}